const topLineup2 = (() => {
  if (document.querySelector("body#pageTop") !== null) {



    let sec = document.querySelector('#jsSecLineup2');
    let wrap = sec.querySelector('.js-tab-wrap');

    let tabs = wrap.querySelectorAll('.js-tab-box');
    let cntnts = wrap.querySelectorAll('.js-cntnt-box');

    tabs.forEach((element, index) => {

      element.addEventListener('click', () => {

        tabs.forEach((element2, index2) => {
          tabs[index2].classList.remove('is-act');
          cntnts[index2].classList.remove('is-act');
        });

        tabs[index].classList.add('is-act');
        cntnts[index].classList.add('is-act');

      });

    });

    tabs[0].classList.add('is-act');
    cntnts[0].classList.add('is-act');



  }
})()
export default topLineup2;